"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEMO_DASHBOARD_RECORD_ID = exports.demoDashboardEndpointIds = void 0;
exports.demoDashboardEndpointIds = {
    DEMO_GET_DASHBOARD_CREATORS: 'DEMO_GET_DASHBOARD_CREATORS',
    DEMO_GET_DASHBOARD_CHARTS_DATA: 'DEMO_GET_DASHBOARD_CHARTS_DATA',
    DEMO_GET_DASHBOARD_DELIVERIES: 'DEMO_GET_DASHBOARD_DELIVERIES',
    DEMO_GET_DASHBOARD_DROP_EVENT: 'DEMO_GET_DASHBOARD_DROP_EVENT',
};
exports.DEMO_DASHBOARD_RECORD_ID = 'demoDashboard';
